declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}

/**
 * ファイルをダウンロードする
 *
 * @param blob ダウンロードするBlob
 * @param content_disposition ファイル名取得要素
 * @param content_type ファイル種別
 */
export const fileDownload = (file: string, content_disposition: string, content_type: string) => {
  const blob = new Blob([file], {
    type: content_type,
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  const file_name = getFileNameFromContentDisposition(content_disposition);
  if (file_name === '') {
    return;
  }
  link.setAttribute('download', file_name);
  document.body.appendChild(link);
  link.onclick = () => {
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(blob, file_name);
    }
  };
  link.click();
  link.remove();
  // ダウンロードリンクノードを削除する
  URL.revokeObjectURL(url);
};

/**
 * レスポンスのヘッダからファイル名を取得する
 *
 * @param content_disposition ファイル名取得要素
 * @return ファイル名
 */
const getFileNameFromContentDisposition = (content_disposition: string): string => {
  const file_name_regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/; // 正規表現でfilenameを抜き出す
  const matches = file_name_regex.exec(content_disposition);
  if (matches !== null && matches[1]) {
    const fileName = matches[1].replace(/['"]/g, '');
    return decodeURI(fileName).replace(/\+/g, ' ');
  } else {
    return '';
  }
};
